import React, { useState } from "react";
import useDomains from "../../hooks/useDomains";
import useTraceSearch from "../../hooks/useTraceSearch";
import SearchForm from "../../components/trace/SearchForm";
import AlertMessage from "../../components/trace/AlertMessage";
import RecordCard from "../../components/trace/RecordCard";
import DataModal from "../../components/trace/DataModal";
import EmptyState from "../../components/trace/EmptyState";


export default function TracePage() {
  const domainOptions = useDomains();
  const {
    records,
    searched,
    searchId,
    loading,
    error,
    result,
    search,
    clearError,
    clearResult,
  } = useTraceSearch();

  const [selected, setSelected] = useState(null); // { record, stage }

  const handleSearch = ({ domain, input }) =>
    search({ domain: domain.value, type: input.type, values: input.values });

  return (
    <div>
      <SearchForm
        domainOptions={domainOptions}
        loading={loading}
        onSearch={handleSearch}
      />

      <div className="container-xxl">
        {error && (
          <AlertMessage type="danger" onClose={clearError}>
            <strong>Search failed.</strong> {error}
          </AlertMessage>
        )}
        {result && !error && (
          <AlertMessage type={result.type} onClose={clearResult}>
            {result.message}
          </AlertMessage>
        )}
      </div>

      <main className="py-4">
        <div className="container-xxl">
          <div className="d-flex flex-column gap-3">
            {records.map((record, index) => (
              <RecordCard
                key={`${searchId}-${record.category}-${record.id}`}
                record={record}
                defaultExpanded={index === 0}
                onViewData={(stage, showAll = false) => setSelected({ record, stage, showAll })}
              />
            ))}
          </div>

          {searched && records.length === 0 && (
            <EmptyState
              title="No records returned"
              text="Check the domain and the values you searched."
            />
          )}
        </div>
      </main>

      {selected && (
        <DataModal
          key={selected.stage.stageNum}
          record={selected.record}
          stage={selected.stage}
          showAll={selected.showAll}
          onClose={() => setSelected(null)}
        />
      )}
    </div>
  );
}